module.exports = __webpack_public_path__ + "images/icons_v2/chevron-up-f0b8e2cd.svg";